module.exports = __webpack_public_path__ + "img/ant-design_menu-outlined-1.a5faa1b4.svg";